import { Box } from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import AvailabilityScheduler from '@product-framework/components/AvailabilityScheduler';

function Availability() {
  const { formatMessage } = useLocalization();

  return (
    <PageSection
      label={formatMessage({
        id: 'SERVICE_PROVIDER_AVAILABILITY_EDIT_HEADING',
        defaultMessage: 'Availability',
      })}>
      <Box>
        <AvailabilityScheduler />
      </Box>
    </PageSection>
  );
}
export default Availability;
